/**
 * Helper to support validation state
 * Requires: Vuelidate
 */
export default {
  methods: {
    /**
     * Get element validation state
     *
     * @param {Object} element Vuelidate $v element
     */
    getValidationState (element) {
      return element.$dirty && !element.$pending && (element.$error || element.$invalid) ? false : element.$dirty && element.$model ? true : null
    },

    /**
     * Set error class based on validation state
     *
     * @param {Object} element Vuelidate $v element
     */
    setErrorState (element) {
      return element.$dirty && !element.$pending && (element.$error || element.$invalid) ? true : element.$dirty && element.$model ? false : null
    }
  }
}
